import { Card, Col, Container, Row, } from "react-bootstrap";

import classic_coffee_img from "./images/frappe/cold-coffee-frappe.png";
import iced_coffee_img from "./images/frappe/iced_coffee.png";
import iced_mocha_img from "./images/frappe/iced_matcha.png";
import cold_coffee_frappe_img from "./images/frappe/cold-coffee-frappe.png";
import hazelnut_frappe_img from "./images/frappe/hazelnut_frappe.png";
import vanilla_frappe_img from "./images/frappe/vanilla_frappe.png";
import caramel_frappe_img from "./images/frappe/caramel_frappe.png";
import cookie_frappe_img from "./images/frappe/cookie_frappe.png";
import irish_cream_frappe_img from "./images/frappe/irish_cream_frappe.png";
import lotus_biscoff_frappe_img from "./images/frappe/lotus-removebg-preview.png";
import nutella_frappe_img from "./images/frappe/nutela_frappe.png";
import mocha_hazelbomb_img from "./images/frappe/mocha-hazel-bomb.png";
import './menu.css'
import NavigationBar from "./nav";
import NewNav from "./canvas";
import Aos from 'aos';
import "aos/dist/aos.css";
import { useEffect } from 'react';

function ColdCoffee() {

  const product_list = [
    { id: 1, product_name: "Classic Cold Coffee", product_img: classic_coffee_img, },
    { id: 2, product_name: "Iced Coffee", product_img: iced_coffee_img, },
    { id: 3, product_name: "Iced Mocha", product_img: iced_mocha_img, },
    { id: 4, product_name: "Cold Coffee Frappe", product_img: cold_coffee_frappe_img, },
    { id: 5, product_name: "Hazelnut Frappe", product_img: hazelnut_frappe_img },
    { id: 6, product_name: "Vanilla Frappe", product_img: vanilla_frappe_img, },
    { id: 7, product_name: "Caramel Frappe", product_img: caramel_frappe_img, },
    { id: 8, product_name: "Cookie Frappe", product_img: cookie_frappe_img, },
    { id: 9, product_name: "Irish Cream Frappe", product_img: irish_cream_frappe_img, },
    { id: 10, product_name: "Lotus Biscoff Frappe", product_img: lotus_biscoff_frappe_img, },
    { id: 12, product_name: "Nutella Frappe", product_img: nutella_frappe_img, },
    { id: 13, product_name: "Mocha Hazel Bomb", product_img: mocha_hazelbomb_img, },
  ];
  useEffect(() => {
    Aos.init({ duration: "1000" })
  })
  return (
    <>
      <Container fluid>
        <Row>
          <NavigationBar />
          <NewNav />
          <Col id='frapeTop'>
            <Row>
              <Col id='rockHeading'>
                <p data-aos="zoom-in">Cold Coffee & frappe</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col
            md={12}
            style={{ justifyContent: "center", gap: "20px" }}
          >
            <Row>
              {product_list.map((product) => (
                <Col
                  xs={3}
                  md={3}
                  key={product.id}
                  style={{
                    marginTop: "20px", textAlign: "center"
                  }}
                >
                  <Card data-aos="zoom-in" style={{ border: "none" }}>
                    <Card.Img id="CardImg"
                      src={product.product_img}
                    />
                    <Card.Body style={{ padding: "5px 0px" }}>
                      <Card.Title id='cardName'>
                        {product.product_name}
                      </Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}
export default ColdCoffee;
